import styled from 'styled-components';
import * as TabsPrimitive from '@radix-ui/react-tabs';

export const TabsRoot = styled(TabsPrimitive.Root)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabsContent = styled(TabsPrimitive.Content)`
  padding-top: 12px;
  flex: 1;
`;

export const TabsTrigger = styled(TabsPrimitive.Trigger)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  padding: 10px 16px;
  border-radius: 6px;
  background-color: transparent;
  color: #6b7280;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #111827;
  }

  &[data-state="active"] {
    background-color: white;
    color: #111827;
    font-weight: 600;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
`;

export const TabsList = styled(TabsPrimitive.List)`
  display: inline-flex; 
  width: fit-content; 
  gap: 4px;
  padding: 4px;
  background-color: #f9fafb;
  border-radius: 8px;
`;
